import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ADPResourceService } from 'digital-core';
import { MatSidenav } from '@angular/material/sidenav';
import { NextStepsInfoDeviceTemplate } from '../components/next-steps/next-steps.component';
import { ImeiInfoDeviceType } from '../components/imei-info/imei-info.component';
import { PghUserDeviceBase } from '../../../shared/device/pgh-user-device';
import { SelectedDeviceService } from '../../../shared/device/selected-device.service';
import { DeviceInfoFormResult } from '../components/cellular-device-info-form/cellular-device-info-form.component';
import { DeviceInventoryService } from '../../../core/services/device-inventory.service';
import { Subject, Subscription, concatMap, tap } from 'rxjs';
import { DeviceDto } from '../../../core/services/device-inventory/device.dto';
import { AccountService } from '../../../core/services/account.service';
import { ImeiLookupDeviceTemplate, ImeiResult } from '../components/imei-lookup/imei-lookup.component';
import { ContractDeviceInventories } from '../../../core/services/contract-device-inventories';
import { SerialLookupDeviceTemplate, SerialResult } from '../components/serial-lookup/serial-lookup.component';
import { EssItemGroup } from '../../../shared/equipment-search/ess-item-group';
import { dashboardRouteWithSlash } from 'src/app/route-constants';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogData } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog-data';
import { MatDialog } from '@angular/material/dialog';
import { UserInfoReportingService } from 'src/app/core/services/user-info-refporting.service';
import { LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { UpdateUserInfoDevicesCountDto } from 'src/app/model/account/update-user-info-devices-count.dto';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'pgh-tablet-registration',
  templateUrl: './tablet-registration.component.html',
  styleUrls: ['./tablet-registration.component.scss']
})
export class TabletRegistrationComponent implements OnInit, OnDestroy {
  private onDestroy$ = new Subject<void>();

  public EssItemGroupEnum = EssItemGroup;

  public states = {
    RegisterTabletNextSteps: 1,
    RegisterImeiQuestionnaire: 2,
    ImeiInfo: 3,
    SerialInfo: 4,
    ProvideAdditionalInfo: 5,
    GenerateQRCode: 6
  }

  public imeiLookupDeviceTemplate = ImeiLookupDeviceTemplate;
  public serialLookupDeviceTemplate = SerialLookupDeviceTemplate;

  @ViewChild('imeisidenav') sidenav: MatSidenav;
  events: string[] = [];
  opened: boolean;

  state = this.states.RegisterTabletNextSteps;
  invitationCode:string;
  invitationId:string;
  imeiStepResult: ImeiResult;
  serialStepResult: SerialResult;
  inventoryId: number;
  backLabel: string;
  hasImei: boolean;
  public imeiInfoDeviceType = ImeiInfoDeviceType.Tablet;
  public nextStepsInfoDeviceTypeTemplate = NextStepsInfoDeviceTemplate.Tablet;

  /**
   * This is the device the user had already selected in a previous step in
   * whatever flow they are in.
   */
  public preSelectedDevice?: PghUserDeviceBase;

  public devicesFromAllInventories?: DeviceDto[];
  private subscriptions: Subscription[] = [];

  private deviceInventories?: ContractDeviceInventories;

  private registerDeviceInProgress = false;

  public isOnboardingFlow:boolean = false;
  public isAdditionalDeviceFlow:boolean =  false;
  public additionalDeviceTypeCode:string='TABL';

  public isBackVisible: boolean = true;
  public userEmail:string;

  constructor(
    public resourceService: ADPResourceService,
    private router: Router,
    public route: ActivatedRoute,
    private location: Location,
    private selectedDeviceService: SelectedDeviceService,
    private deviceInventoryService: DeviceInventoryService,
    private accountService: AccountService,
    private dialog: MatDialog,
    private userInfoReportingService: UserInfoReportingService,
    private loggedInUserSettingsService: LoggedInUserSettings,
    private storageService: StorageService
  ) { }

  ngOnInit(): void {
    this.backLabel = this.resourceService.getPortaLabelValue("Global_Button_Back");

    this.route.queryParams.subscribe(params => {
      this.isOnboardingFlow = (params.isOnboardingFlow && params.isOnboardingFlow.toLowerCase().trim() === 'true');
    });

    this.route.queryParams.subscribe(params => {
      this.isAdditionalDeviceFlow = (params.isAdditionalDeviceFlow && params.isAdditionalDeviceFlow.toLowerCase().trim() === 'true');
    });

    if(!this.isAdditionalDeviceFlow){
      this.preSelectedDevice = this.selectedDeviceService.getSelectedDevice();
    }

    this.accountService.getAllInventoriesWithDevicesForSelectedContract(this.onDestroy$).subscribe({
      next: (inventories) => {
        this.deviceInventories = inventories;

        this.devicesFromAllInventories = [
          ...(inventories?.cellularEnabledPolicyInventory?.devices ?? []),
          ...(inventories?.gadgetPolicyInventory?.devices ?? []),
          ...(inventories?.gadgetClientSoldPolicyInventory?.devices ?? []),
          ...(this.deviceInventoryService?.getEprismDevices()),
        ];
      },
      error: (error) => {
        throw error;
      }
    });
    this.loggedInUserSettingsService.$userClaims.subscribe({
      next: (user)=>{
        this.userEmail = user.email;
      }
    })
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  changeState(state: any): void {
    this.state = state;
    if (this.state == this.states.RegisterImeiQuestionnaire || this.state == this.states.SerialInfo || this.state == this.states.ImeiInfo || this.state == this.states.RegisterTabletNextSteps || this.state == this.states.ProvideAdditionalInfo) {
      this.backLabel = this.resourceService.getPortaLabelValue("Global_Button_Back");
    } else {
      if(!this.isAdditionalDeviceFlow){
        this.backLabel = this.resourceService.getPortaLabelValue("RegisterNumber_Back_To_My_Devices"); // This is for the QR Code screen
      }
      else{
        this.isBackVisible=false;
      }
      //this.backLabel = this.resourceService.getPortaLabelValue("RegisterNumber_Back_To_My_Devices"); // This is for the QR Code screen
    }
    this.gotoTop();
  }
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  handleBack() {
    if (this.state == this.states.RegisterTabletNextSteps) {
      if (window.history.length > 1) {
        this.location.back();
      } else {
        this.router.navigate([this.resourceService.getPortalSetting("URL_MyDevices").Value]);
      }
    } else if (this.state == this.states.RegisterImeiQuestionnaire) {
      this.changeState(this.states.RegisterTabletNextSteps);
    } else if (this.state == this.states.ImeiInfo) {
      this.changeState(this.states.RegisterImeiQuestionnaire);
    } else if (this.state == this.states.SerialInfo) {
      this.changeState(this.states.RegisterImeiQuestionnaire);
    } else if (this.state == this.states.ProvideAdditionalInfo) {
        if(this.hasImei){
        this.changeState(this.states.ImeiInfo);
        }else{this.changeState(this.states.SerialInfo);}
    } else {
      this.router.navigate([this.resourceService.getPortalSetting("URL_MyDevices").Value]);
    }
  }
  closeSideNav() {
    this.sidenav.close();
  }

  handleImeiLookupCompleted(result: ImeiResult) {
    this.imeiStepResult = result;
    this.changeState(this.states.ProvideAdditionalInfo);
  }

  handleSerialLookupCompleted(result: SerialResult) {
    this.serialStepResult = result;
    this.changeState(this.states.ProvideAdditionalInfo);
  }

  handleImeiQuestionnaireCompleted(deviceHasImei: boolean){
    if (deviceHasImei) {
      this.changeState(this.states.ImeiInfo);
      this.hasImei = true;
    } else {
      this.changeState(this.states.SerialInfo);
      this.hasImei = false;
    }
  }

  handleDeviceInfoFormSubmitted(deviceFormResult: DeviceInfoFormResult) {
    const isEprism = this.storageService.getLocal<string>(`IsEprismOnly`);
    if (this.registerDeviceInProgress || isEprism == 'true') {
      return;
    }
    this.registerDeviceInProgress = true;

    if (this.hasImei) {
      this.inventoryId = this.deviceInventories?.cellularEnabledPolicyInventory ? this.deviceInventories?.cellularEnabledPolicyInventory?.info?.id : this.deviceInventories?.gadgetPolicyInventory?.info?.id;
    } else if(!this.hasImei) {
      this.inventoryId = this.deviceInventories?.gadgetPolicyInventory?.info?.id;
      // Reset imei value to null to guarantee it does not have a value if serial number chosen after imei input in same flow
      this.imeiStepResult = null;
    }

    const createDeviceDto = this.deviceInventoryService.buildCreateDeviceBodyDtoFromSerialSearchEquipmentInfo(
      this.inventoryId, deviceFormResult, this.imeiStepResult?.imei, this.serialStepResult?.serial, 'TABL');

    this.deviceInventoryService.createDevice(createDeviceDto).pipe(
      tap(device => this.selectedDeviceService.updateAllDevices(this.deviceInventoryService.buildPghUserDeviceBaseFromDeviceDto(device))),
      tap(() => this.deviceInventoryService.clearCache()),
      concatMap(device => this.accountService.registerInvitationToDevice(device.id, device.inventoryId, false)),
    ).subscribe({
      next: (res) => {
        this.invitationCode = res.invitationCode;
        this.invitationId = res.id;
        this.changeState(this.states.GenerateQRCode);
        this.registerDeviceInProgress = false;

         //update the user's inventory device count in the UserInfo db
        const updateUserInfoDevicesCountDto : UpdateUserInfoDevicesCountDto = {
          EmailAddress: this.userEmail,
          DeviceCount: this.selectedDeviceService.getAllDevices().length
        }
        this.userInfoReportingService.updateUserInfoDevicesCount(updateUserInfoDevicesCountDto).subscribe({error: (err) => { throw err;}});
      },
      error: (error) => {
        this.registerDeviceInProgress = false;
        throw error;
      },
    });
  }
  public handleExitToDashboard(){

    let dialogData: ConfirmationDialogData;

    dialogData = {
        title: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Title",
        message: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Message",
        cancelButtonText: "Global_Button_SkipForNow",
        confirmButtonText: "Global_Button_ContinueTest",
        contextData: { titleLeftAligned: false }
      };

    const confirmationDialog = this.dialog.open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(ConfirmationDialogComponent, {
      data: dialogData
    });
    this.subscriptions.push(confirmationDialog.afterClosed().subscribe({
      next: (result) => {
        if (result.toString() === 'false') {
          this.router.navigate([dashboardRouteWithSlash]);
        }
      }
    }));
  }
}
